// TeamPopup.vue

<template>
    <v-dialog v-model="dialog" max-width="800px" persistent>
      	<v-card>
	        <v-card-title>
	          <span class="headline">Team</span>
	        </v-card-title>
	        <v-card-text>
	        	<v-form>
	        		<v-text-field disabled label="ID" v-model="item.id"></v-text-field>
	        		<v-layout>
	        			<v-flex xs5>
	        				<v-text-field label="Name" v-model="item.name"></v-text-field>
			        	</v-flex>
			        	<v-spacer />
					</v-layout>
	        	</v-form>
	        </v-card-text>
        	<v-card-actions>
        		<v-btn text class="warning mx-1 mt-3" @click="onCancel()">Abbrechen</v-btn>
        		<v-btn v-if="!error" text class="success mx-0 mt-3" :loading="loading" :disabled="loading" @click="onSubmit()">Speichern</v-btn>
        		<v-btn v-else text class="error mx-0 mt-3" disabled>{{ error }}</v-btn>
			    <v-spacer />
        	</v-card-actions>
      	</v-card>
		<v-dialog v-model="showmessage">
			<v-toolbar dark color="warning" dense>
				<v-toolbar-title class="white--text">Notification</v-toolbar-title>
			</v-toolbar>
			<v-card tile>
				<v-card-text color="red" v-html="message"/>
				<v-card-actions>
					<v-spacer/>
					<v-btn color="blue" text @click="onMessageClose()">Ok</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
    </v-dialog>          
</template>

<script>
	import { mapGetters } from 'vuex'
	export default {
	  	name: 'TeamPopup',
		components: {
		},
	  	props: {
	  		model: {
	  			type: Object,
	  			default () {
	  				return {}
	  			}
	  		},
	  	},
		data() {
			return {
				dialog: false,
				loading: false,
				error: '',
				message: '',
				showmessage: false,
			}
		},
		computed: {
			...mapGetters({
				item: 'teams/getTeam',
			}),
		},
		methods: {
			closeDialog(event) {
    			this.loading = false
				this.dialog = false
      			this.$store.commit('teams/resetTeam')
	      		this.$emit(event)
			},
			msgError(msg) {
    			this.loading = false
    			this.error = "Eingaben konnten nicht gespeichert werden"
		        setTimeout(() => {
		        	this.error = ''
		        }, 5000);
		        this.message = '<code>' + JSON.stringify(msg).substring(0, 200) + '</code>'
		        this.showmessage = true
			},
			onSubmit() {
	        	this.loading = true	
		        const data = this.item
				let self = this
	      		this.$store.dispatch('teams/storeTeam', data)
	      		.then((response) => {
	      			self.closeDialog('popup-submitted')
      			})
		    	.catch((error) => {
		    		console.log('teams->submit->error')
			    	console.log(error)
			    	self.msgError(error.response.data)
			    });
			},
			onCancel() {
	      		this.closeDialog('popup-cancelled')
			},
			onMessageClose() {
		        this.message = ''
		        this.showmessage = false			
			},
			fetchData(id) {
				this.loading = true
				let self = this
				this.$store.dispatch('teams/editTeam', id)
				.then((response) => {
					self.loading = false
				})
				.catch((error) => {
					console.log(error)
					self.loading = false
				});
			},
		},
		mounted() {
		},
	  	watch: {
		    model (newValue) {
			    if(newValue && typeof newValue === 'object' && Object.keys(newValue).length !== 0) {
			    	this.fetchData(this.model.id)
			    } else if(newValue && typeof newValue === 'object' && Object.keys(newValue).length === 0) {
			    }
				this.dialog = true
		    },
	  	},
	}  
</script>

<style>
</style>